// extracted by mini-css-extract-plugin
export var avatar = "_lr-3";
export var avatarContainer = "_lr-2";
export var avatarSpacer = "_lr-5";
export var avatarSpacerContainer = "_lr-4";
export var avatarStackContainer = "_lr-1";
export var bubble = "_lr-0";
export var remainderBubble = "_lr-6";